// OBSOLETE
export class AiInterviewQuestion {
  id?: string;
  order: number;
  questionText: string;
  numberProbeQuestions: number;
  stimulusMediaId: string;
  stimulusName: string;
  mediaType?: string;
  mediaSize?: string;
}
